import { render } from "./editFirstPlace.vue?vue&type=template&id=0d9be18e"
import script from "./editFirstPlace.vue?vue&type=script&lang=js"
export * from "./editFirstPlace.vue?vue&type=script&lang=js"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__